<template>
  <div>
    <div class="order-confirm">
      <div class="order-status" v-if="orderInfo.status && serviceOrderState">
        <span :class="['status-text', `status-${orderInfo.status}`]">{{
          serviceOrderState.getValueByKey(orderInfo.status)
        }}</span>
      </div>
      <div class="address-item" @click="selectAddr">
        <div class="address-content">
          <i class="iconfont icon-shdz" />
          <div class="address-info">
            <h3 class="address-name">
              <span>{{ orderInfo.addressName }}</span>
              <span class="address-phone">{{ orderInfo.addressMobile }}</span>
            </h3>
            <p class="address-area" v-if="orderInfo.addressProvinceName">{{ showArea(orderInfo) }}</p>
          </div>
        </div>
      </div>
      <div class="product-list" v-if="orderInfo.sum">
        <div class="product-item" v-for="product in orderInfo.mallOrderDetailVoList" :key="product.id">
          <div class="product-content">
            <div class="item-img">
              <van-image fit="cover" :src="product.goodsIcon" />
            </div>
            <div class="product-details">
              <drugTag :product="product" />
              <p class="product-description">{{ product.goodsFunction }}</p>
              <div class="product-foot">
                <span class="product-price">x{{ product.number }}</span>
                <span class="product-price">￥{{ product.salePrice }}</span>
                <!-- <stepper
                  v-model="product.number"
                  theme="round"
                  button-size="22"
                  disable-input
                  min="1"
                  max="99"
                  @change="refreshInfo"
                /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="price-info">
        <div class="price-box">
          <span>实付款</span>
          <span class="price price-total">￥{{ orderInfo.payAmount }}</span>
        </div>
        <div class="price-box">
          <span>订单金额</span>
          <span class="info">￥{{ orderInfo.amount }}</span>
        </div>
        <div class="price-box">
          <span>配送金额</span>
          <span class="info">￥{{ orderInfo.deliveryAmount }}</span>
        </div>
        <div class="price-box">
          <span>会员积分抵扣</span>
          <span class="info">- ￥{{ orderInfo.realDeductionAmount }}</span>
        </div>
        <div class="price-box">
          <span>消费积分抵扣</span>
          <span class="info">- ￥{{ orderInfo.realConsumptionAmount }}</span>
        </div>
        <div class="price-box">
          <span>订单编号</span>
          <span class="info">{{ orderInfo.orderCode }}</span>
        </div>
        <div class="price-box">
          <span>订单备注</span>
          <span class="info">{{ orderInfo.remark || '无' }}</span>
        </div>
        <div class="price-box">
          <span>下单时间</span>
          <span class="info">{{ orderInfo.createTime }}</span>
        </div>
        <template v-if="!['0'].includes(orderInfo.status)">
          <div class="price-box">
            <span>支付时间</span>
            <span class="info">{{ orderInfo.payTime }}</span>
          </div>
        </template>
      </div>
    </div>
    <div @click="rxInfo" class="rx-btn" v-if="orderInfo.rxId">查看<br />处方</div>
    <div style="height: 100px"></div>
    <fixedButton text="微信支付" v-if="showPayBtn" @emitEvent="wxPay" class="wx" />
  </div>
</template>

<script>
import drugTag from '@/components/drugTag';

import services from '@/service';
import fixedButton from '@/components/fixedButton';
import { Image as VanImage } from 'vant';
import { mapGetters } from 'vuex';
import { isWeChat, isMiniProgram } from '@/global';
import wechat from '@/wechat';
import pay from '@/lib/pay';
import { serviceOrderStateAll } from '@/enum/index';
import { onlineCheck } from '@/lib/utils';

export default {
  name: 'mallOrderDetail',
  components: { drugTag, fixedButton, VanImage },
  data() {
    return {
      address: {},
      products: [],
      timer: null,
      toCheck: false,
      orderInfo: {},
      orderCode: '',
      serviceOrderId: '',
      serviceOrderState: {},
      onceAutoPay: true,
      autoPay: '0'
    };
  },
  computed: {
    ...mapGetters(['openId', 'clinicInfo', 'addressInfo']),
    hasCartNum() {
      return this.products.reduce((sum, product) => sum + product.number, 0);
    },
    cartTotalPrice() {
      return this.products.reduce((sum, product) => sum + product.number * product.salePrice, 0) * 100;
    },
    code() {
      return this.$route.query.code;
    },
    hasOrder() {
      return this.orderCode;
    },
    hasRx() {
      return this.orderInfo.rxFlag === '1';
    },
    canPay() {
      return ['0'].includes(this.orderInfo.status) && this.orderInfo.payAmount > 0;
    },
    showPayBtn() {
      let tag = false;
      if (this.canPay) {
        if (this.hasRx && this.orderInfo.rxStatus === '2') {
          tag = true;
        } else if (!this.hasRx) {
          tag = true;
        }
      }
      return tag;
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    async getOpenId() {
      if (isWeChat && !this.openId && this.code) {
        const res = await services.common.getOpenId({ authorizeCode: this.code });
        this.$store.dispatch('set_openId', res.data.openId);
      }
    },
    showArea(item) {
      return `${item.addressProvinceName} ${item.addressCityName} ${item.addressRegionName} ${item.addressDetail}`;
    },
    onSubmit() {},
    rxInfo() {
      this.$router.push({
        name: 'mallPrescriptionDetail',
        query: {
          id: this.orderInfo.mallOrderId
        }
      });
    },
    selectAddr() {
      if (this.hasOrder) return;
      this.$router.push({
        name: 'mallMyAddress',
        query: {
          isSelect: true
        }
      });
    },
    async createOrder() {
      this.$store.dispatch('addLoading');
      const params = {
        addressCityName: this.addressInfo.city,
        addressDetail: this.addressInfo.address,
        addressMobile: this.addressInfo.phone,
        addressName: this.addressInfo.addressee,
        addressProvinceName: this.addressInfo.province,
        addressRegionName: this.addressInfo.district,
        clinicId: this.clinicInfo.clinicId,
        clinicName: this.clinicInfo.clinicName,
        orderDetailVoList: this.products.map(i => {
          return {
            goodsMealId: i.goodsMealId,
            number: i.number
          };
        })
      };
      const orderRes = await services.mall.createServiceOrder(params);
      this.orderCode = orderRes.data.orderCode;
      this.$store.dispatch('subLoading');

      this.successHandle();

      // if (this.payAmount === 0) {
      //   this.successHandle();
      // } else {
      //   this.wxPay();
      // }
    },
    async wxPay() {
      await onlineCheck();
      if (isMiniProgram) {
        const data = {
          orderCode: this.orderCode,
          tradeType: 'JSAPI'
        };
        wechat.$wx.miniProgram.navigateTo({ url: `/pages/miniH5Pay/index?data=${JSON.stringify(data)}` });
        if (!this.toCheck) {
          this.checkOrderStatus();
        }
      } else {
        this.$store.dispatch('addLoading');
        const res = await services.mall.wxPay({
          orderCode: this.orderCode,
          tradeType: 'JSAPI',
          openId: this.openId
        });
        this.$store.dispatch('subLoading');

        await pay(res.data);
        this.successHandle();
      }
    },
    successHandle() {
      //刷新页面
      window.location.reload();
    },
    async calculatePrice() {
      if (!this.products.length) return;
      this.$store.dispatch('addLoading');

      const params = {
        addressCityName: this.addressInfo.city,
        addressDetail: this.addressInfo.address,
        addressMobile: this.addressInfo.phone || this.clinicInfo.phone,
        addressName: this.addressInfo.addressee,
        addressProvinceName: this.addressInfo.province,
        addressRegionName: this.addressInfo.district,
        clinicId: this.clinicInfo.clinicId,
        clinicName: this.clinicInfo.clinicName,
        orderDetailVoList: this.products.map(i => {
          return {
            goodsMealId: i.goodsMealId,
            number: i.number
          };
        })
      };
      const res = await services.mall.calculatePrice(params);
      this.orderInfo = res.data;
      this.products = res.data.orderDetailVoList;
      this.$store.dispatch('subLoading');
    },
    async getOrderDetail() {
      const res = await services.mall.getServiceOrder(this.serviceOrderId);
      this.orderInfo = res.data;
      this.orderCode = res.data.orderCode;
      this.products = res.data.mallOrderDetailVoList;

      if (this.showPayBtn && this.onceAutoPay && this.autoPay === '1') {
        this.onceAutoPay = false;
        this.wxPay();
      }
    },
    checkOrderStatus() {
      this.toCheck = true;
      this.timer = setInterval(this.pollOrderStatus, 1000);
    },
    async pollOrderStatus() {
      await this.getOrderDetail();
      if (!['0', '2'].includes(this.orderInfo.status)) {
        clearInterval(this.timer);
        this.successHandle();
        //
        // this.$toast('支付成功');
        // this.$router.replace({
        //   name: 'mallMyOrder'
        // });
      }
    },
    refreshInfo() {
      this.calculatePrice();
    }
  },
  async mounted() {
    this.serviceOrderState = await serviceOrderStateAll();
    this.$store.dispatch('addLoading');
    await this.getOpenId();
    const info = JSON.parse(window.atob(this.$route.query.state) || {});
    console.log(info);
    this.orderCode = info.orderCode;
    this.serviceOrderId = info.serviceOrderId;
    this.autoPay = info.autoPay;
    this.getOrderDetail();

    // this.products = products;
    // this.calculatePrice();
  }
};
</script>

<style lang="scss" scoped>
.order-status {
  background: #fff;
  padding: $tb $lr;
  margin-bottom: $tb;
  border-radius: $radius;
  box-shadow: $box-shadow1;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.status-text {
  font-size: $size2;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.9);
  position: relative;
  z-index: 1;
}

.status-0 {
  color: $red1;
  background: rgba($red1, 0.1);
}

.status-1 {
  color: $appcolor;
  background: rgba($appcolor, 0.1);
}

.status-2 {
  color: #2196f3;
  background: rgba(33, 150, 243, 0.1);
}

.status-3 {
  color: #9c27b0;
  background: rgba(156, 39, 176, 0.1);
}

.status-4 {
  color: #ff9800;
  background: rgba(255, 152, 0, 0.1);
}

.order-confirm {
  padding: $tb $lr;
}

.address-item {
  border-bottom: 1px solid $bordercolor;
  background: #fff;
  padding: $tb $lr;
  // margin: $tb $lr;
  border-radius: $radius;
  overflow: hidden;
  position: relative;
  box-shadow: $box-shadow1;
}

.address-content {
  display: flex;
  align-items: center;

  .icon-shdz {
    font-size: 32px;
    margin-right: $lr;
    color: transparent; /* 将iconfont的颜色改为透明 */
    -webkit-background-clip: text; /* 将背景图的绘画仅作用在文字上 */
    background-image: $btnbg;
  }
}

.address-image {
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 5px;
  margin-right: $lr;
}

.address-avatar {
  width: 100%;
  height: auto;
}

.address-info {
  flex: 1;
}

.address-name {
  margin-bottom: $tb;
  font-size: $size2;
  font-weight: 500;
  color: $black1;
  .address-phone {
    font-size: $size4;
    margin: 0 $lr;
  }
}

.address-area {
  color: $gray2;
  font-size: $size4;
  line-height: 20px;
}

.view-details {
  font-size: $size1;
  color: $appcolor;
}
.product-list {
  // display: flex;
  // flex-wrap: wrap;
  // justify-content: center;
  box-shadow: $box-shadow1;
  border-radius: 5px;
  background: #fff;
  margin: $tb 0;
  overflow: hidden;
}

.price-info {
  box-shadow: $box-shadow1;
  border-radius: 5px;
  background: #fff;
  margin: $tb 0;
  padding: $tb $lr;
  font-size: $size5;
  color: $gray1;

  .price-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: right;
    > :first-child {
      color: $gray2;
    }
    &:not(:last-child) {
      margin-bottom: $tb;
    }
    .price {
      color: $red1;
      font-weight: 600;
      margin-left: $lr;
    }
  }

  .price-total {
    font-size: $size2;
  }
}

.product-item {
  flex: 1;
  border-bottom: 1px solid $bordercolor;
  padding: $tb 0;
  margin: 0 $lr;
  &:last-child {
    border: none;
  }
}

.product-content {
  display: flex;
  align-items: center;
}

.item-img {
  width: 80px;
  height: 80px;
  margin-right: 12px;
  border-radius: $radius;
  overflow: hidden;

  .van-image {
    width: 100%;
    height: 100%;
  }
}

.product-details {
  flex: 1;
  .product-foot {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // padding-right: $lr;
  }
}

.product-name {
  color: $black1;
  margin-bottom: $tb;
  font-size: $size5;
}

.product-description {
  color: $gray2;
  margin-bottom: $tb;
  font-size: $size4;
  @include hiddenText();
}

.product-price {
  // font-weight: 600;
  color: $black1;
}

.van-submit-bar {
  bottom: $tabbarHeight;
}
.cart-icon {
  font-size: 24px;
  &.active {
    color: $appcolor;
  }
}

.rx-btn {
  position: fixed;
  right: 30px;
  bottom: 75px;
  width: 55px;
  height: 55px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1976d2, #64b5f6);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  line-height: 1.2;
  text-align: center;
  box-shadow: 0 4px 12px rgba(25, 118, 210, 0.3);
  z-index: 99;
  transition: all 0.3s ease;

  &:active {
    transform: scale(0.95);
  }
}
</style>
